import { AuthUserGroup } from "~/types/auth";

/**
 * The one role list that reaches Indy. Consumed by the /indy route guard
 * (routes.tsx) and by MainLayout's `canUseIndy` (navbar tab, floating panel,
 * corner launcher, Cmd+K) so the entry points and the route can never drift:
 * widening one without the other either 403s a visible tab or leaves a rendered
 * surface unreachable. Doctors are deliberately absent — they have never had an
 * Indy entry point. The ENABLED_CHATBOT feature flag is layered on top by each
 * consumer (roles are known synchronously; the flag loads async).
 */
export const INDY_ALLOWED_GROUPS: AuthUserGroup[] = [
  AuthUserGroup.ADMIN,
  AuthUserGroup.MEDICAL_ASSISTANT,
  AuthUserGroup.HISTORIAN,
];

/** Role check for Indy surfaces; `null` (still resolving) is not allowed. */
export const canAccessIndy = (userGroup: AuthUserGroup | null): boolean =>
  userGroup !== null && INDY_ALLOWED_GROUPS.includes(userGroup);
